// Mock data for PercentageCalculatorPlus

export const financialCalculators = [
  { name: "Mortgage Calculator", path: "/mortgage-calculator" },
  { name: "Loan Calculator", path: "/loan-calculator" },
  { name: "Auto Loan Calculator", path: "/auto-loan-calculator" },
  { name: "Interest Calculator", path: "/interest-calculator" },
  { name: "Payment Calculator", path: "/payment-calculator" },
  { name: "Retirement Calculator", path: "/retirement-calculator" },
  { name: "Amortization Calculator", path: "/amortization-calculator" },
  { name: "Investment Calculator", path: "/investment-calculator" },
  { name: "Inflation Calculator", path: "/inflation-calculator" },
  { name: "Finance Calculator", path: "/finance-calculator" },
  { name: "Income Tax Calculator", path: "/income-tax-calculator" },
  { name: "Compound Interest Calculator", path: "/compound-interest-calculator" },
  { name: "Salary Calculator", path: "/salary-calculator" },
  { name: "Interest Rate Calculator", path: "/interest-rate-calculator" },
  { name: "Sales Tax Calculator", path: "/sales-tax-calculator" }
];

export const fitnessCalculators = [
  { name: "BMI Calculator", path: "/bmi-calculator" },
  { name: "Calorie Calculator", path: "/calorie-calculator" },
  { name: "Body Fat Calculator", path: "/body-fat-calculator" },
  { name: "BMR Calculator", path: "/bmr-calculator" },
  { name: "Ideal Weight Calculator", path: "/ideal-weight-calculator" },
  { name: "Pace Calculator", path: "/pace-calculator" },
  { name: "Pregnancy Calculator", path: "/pregnancy-calculator" },
  { name: "Pregnancy Conception Calculator", path: "/pregnancy-conception-calculator" },
  { name: "Due Date Calculator", path: "/due-date-calculator" }
];

export const mathCalculators = [
  { name: "Scientific Calculator", path: "/scientific-calculator" },
  { name: "Fraction Calculator", path: "/fraction-calculator" },
  { name: "Percentage Calculator", path: "/percentage-calculator" },
  { name: "Random Number Generator", path: "/random-number-generator" },
  { name: "Triangle Calculator", path: "/triangle-calculator" },
  { name: "Standard Deviation Calculator", path: "/standard-deviation-calculator" }
];

export const otherCalculators = [
  { name: "Age Calculator", path: "/age-calculator" },
  { name: "Date Calculator", path: "/date-calculator" },
  { name: "Time Calculator", path: "/time-calculator" },
  { name: "Hours Calculator", path: "/hours-calculator" },
  { name: "GPA Calculator", path: "/gpa-calculator" },
  { name: "Grade Calculator", path: "/grade-calculator" },
  { name: "Concrete Calculator", path: "/concrete-calculator" },
  { name: "Subnet Calculator", path: "/subnet-calculator" },
  { name: "Password Generator", path: "/password-generator" },
  { name: "Conversion Calculator", path: "/conversion-calculator" }
];

export const categoryImages = {
  financial: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=280&h=180&fit=crop",
  fitness: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=280&h=180&fit=crop",
  math: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=280&h=180&fit=crop",
  other: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=280&h=180&fit=crop"
};
